import { CityCampaignModules } from "@l2r-front/l2r-app-city"

export const CampaignModules = [...CityCampaignModules]  